const brandingSettings = {
  default: {
    css: "./assets/styles/themes/variables.css",
    name: "sophyapp",
    imagePath: "/images/sophy_full_main_logo.jpg",
    icon: "/favicon.ico",
    title: "Patientenportal sophyapp",
    manifest: "/manifest.json",
    appleTouchIcon: "/logo192.png",
    // dev/staging hosts set their own therapist app in the env
    therapistUrl:
      process.env.REACT_APP_THERAPIST_APP_URL || "https://therapeut.sophyapp.com",
  },
  "medfit.ch": {
    css: "./assets/styles/themes/medfit.css",
    name: "medfit",
    imagePath: "/images/ci/medfit/medfit1.jpg",
    icon: "/images/ci/medfit/faviconV2.ico",
    title: "Fit für Morgen!",
    manifest: "/manifestMedfit.json",
    appleTouchIcon: "/images/ci/medfit/medfitApp192_.png",
    therapistUrl: "https://therapeut.medfit.ch",
  },
  "medaix-exercise.de": {
    css: "./assets/styles/themes/medaix.css",
    name: "medaix",
    imagePath: "/images/ci/medaix/medaix_logo.png",
    icon: "/images/ci/medaix/favicon.ico",
    title: "MedAix Exercise",
    manifest: "/manifestMedaix.json",
    appleTouchIcon: "/images/ci/medaix/icon_192x192.png",
    therapistUrl: "https://therapeut.medaix-exercise.de",
  },
  "therapiecentral.at": {
    css: "./assets/styles/themes/therapiecentral.css",
    name: "therapiecentral",
    imagePath: "/images/ci/therapie_central/TherapieCentral.jpg",
    title: "Therapie Central",
    icon: "/images/ci/therapie_central/favicon.ico",
    manifest: "/manifestTherapieCentral.json",
    appleTouchIcon: "/images/ci/therapie_central/apple-touch-icon.png",
    therapistUrl: "https://therapeutapp.therapiecentral.at",
  },
};

export function getBrandingSettings(hostname) {
  const key = Object.keys(brandingSettings).find((key) =>
    hostname.endsWith(key)
  );
  return brandingSettings[key] || brandingSettings.default;
}
